import axios from "@/utils/axios";

export const getRoles = async () => (await axios.get("/roles")).data.data || [];
export const getPermissions = async () => (await axios.get("/roles/permissions")).data.data || {};
export const createRole = async (payload) => (await axios.post("/roles", payload)).data.data;
export const updateRole = async (id, payload) => (await axios.put(`/roles/${id}`, payload)).data.data;
export const deleteRole = async (id) => (await axios.delete(`/roles/${id}`)).data;
